import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ebb-portal-dialog-confirm-message',
  templateUrl: './dialog-confirm-message.component.html'
})
export class DialogConfirmMessageComponent implements OnInit {
  message: string;
  buttonlabel:string;
  buttonCancelLabel:string;
  
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.buttonCancelLabel = data.buttonCancelLabel;
    this.message = data.message;
    this.buttonlabel = data.buttonlabel;
  }

  ngOnInit() {}

  onClickCancel(): void {
    this.dialogRef.close(0);
  }

  onClickClose(): void {
    this.dialogRef.close(1);
  }
}
